export const subscribe = async (url, email) => {
  const resp = await fetch(
    `https://us-central1-kids-qualitytime.cloudfunctions.net/suggest_edit`,
    {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain, */*"
      },
      body: JSON.stringify({
        text: "SUBSCRIBE_FIND_CLASSES",
        email,
        url
      })
    }
  );
  return resp.json();
};

export const publishData = async id => {
  const resp = await fetch(
    `https://us-central1-kids-qualitytime.cloudfunctions.net/publish_data`,
    {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain, */*"
      },
      body: JSON.stringify({
        id: id
      })
    }
  );
  return resp.json();
};
